export const MongodbAtlasIconUrl = "https://www.mongodb.com/favicon.ico";
